<template>
  <div class="tabla-wrap">
    <div class="tabla-scroll">
      <table class="tabla">
        <thead>
          <tr class="th-row">
            <th>Folio</th>
            <th>Plan / Hallazgo</th>
            <th>Área</th>
            <th>Responsable</th>
            <th>Estatus / Avance</th>
            <th>Compromiso</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="p in planes"
            :key="p.idPlan"
            class="tr"
            title="Ver detalle del plan"
            @click="$emit('abrir', p)"
          >
            <td class="td-folio">
              {{ p.folio }}
              <div class="folio-claim">{{ p.folioClaim }}</div>
            </td>
            <td class="td-titulo">
              <div class="titulo">{{ p.titulo }}</div>
              <div class="cliente">{{ p.cliente }}</div>
              <div class="asunto">{{ p.asunto }}</div>
            </td>
            <td>
              <PortalBadge :text="p.area" :color="p.areaColor || colorArea(p.area)" />
            </td>
            <td class="td-resp">
              <div :class="{ pendiente: !p.responsable }">
                {{ p.responsable || "Sin designar" }}
              </div>
              <div
                class="prio"
                :style="{ color: PRIORIDAD_COLOR[p.prioridad] || '#64748b' }"
              >
                {{ p.prioridad }}
              </div>
            </td>
            <td>
              <PortalBadge
                :text="p.estatusDesc || estatusLabel(p.estatus)"
                :color="p.estatusColor || estatusColor(p.estatus)"
              />
              <div class="avance-track">
                <div
                  class="avance-fill"
                  :style="{
                    width: (p.avance || 0) + '%',
                    background: p.areaColor || colorArea(p.area),
                  }"
                ></div>
              </div>
              <div class="avance-num">{{ Math.round(p.avance || 0) }}%</div>
            </td>
            <td>
              <span class="sem" :style="{ color: semaforo(p).color }">
                <PortalIcon
                  v-if="semaforo(p).key === 'rojo'"
                  name="AlertTriangle"
                  :size="12"
                />
                <PortalIcon
                  v-else-if="['naranja', 'amarillo'].includes(semaforo(p).key)"
                  name="Clock"
                  :size="12"
                />
                {{ semaforo(p).label }}
              </span>
              <div class="sem-fecha">{{ fmtFecha(p.fechaCompromiso) }}</div>
              <!-- RN-05: la fecha original solo se muestra si alguien la movió. -->
              <div
                v-if="fechaMovida(p)"
                class="sem-original"
                title="Fecha compromiso original, antes del cambio aprobado"
              >
                original: {{ fmtFecha(p.fechaCompromisoOriginal) }}
              </div>
              <div v-if="p.sinSeguimiento === 'S'" class="sin-seg">
                Sin actualización
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!planes.length" class="empty">{{ vacio }}</div>
  </div>
</template>

<script>
import PortalIcon from "./PortalIcon.vue";
import PortalBadge from "./PortalBadge.vue";
import { colorArea } from "./portal.helpers";
import { PRIORIDAD_COLOR } from "./portal.constants";
import { semaforo, fmtFecha, estatusLabel, estatusColor } from "./cx.rules";

export default {
  name: "PlanTable",
  components: { PortalIcon, PortalBadge },
  props: {
    planes: { type: Array, default: () => [] },
    vacio: { type: String, default: "No hay planes con estos filtros." },
  },
  emits: ["abrir"],
  data() {
    return { PRIORIDAD_COLOR };
  },
  methods: {
    colorArea,
    semaforo,
    fmtFecha,
    estatusLabel,
    estatusColor,
    fechaMovida(p) {
      return (
        p.fechaCompromisoOriginal &&
        p.fechaCompromisoOriginal !== p.fechaCompromiso
      );
    },
  },
};
</script>

<style scoped>
.tabla-wrap {
  background: var(--pt-card);
  border: 1px solid var(--pt-border);
  border-radius: 16px;
  overflow: hidden;
}
.tabla-scroll {
  overflow-x: auto;
}
.tabla {
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;
  font-size: 14px;
}
.th-row th {
  text-align: left;
  font-size: 12px;
  text-transform: uppercase;
  color: var(--pt-muted);
  font-weight: 600;
  padding: 12px;
  border-bottom: 1px solid var(--pt-border);
}
.tr {
  cursor: pointer;
}
.tr:hover td {
  background: var(--pt-elev);
}
.tr td {
  padding: 12px;
  vertical-align: top;
  border-bottom: 1px solid var(--pt-line);
}
.td-folio {
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.folio-claim {
  font-weight: 400;
  font-size: 11px;
  color: var(--pt-muted);
  margin-top: 2px;
}
.td-titulo {
  max-width: 320px;
}
.titulo {
  color: var(--pt-text);
  font-weight: 500;
}
.cliente {
  color: var(--pt-dim);
  font-size: 12px;
}
.asunto {
  color: var(--pt-muted);
  font-size: 11px;
  margin-top: 2px;
}
.td-resp {
  font-size: 13px;
  color: var(--pt-dim);
}
.prio {
  font-size: 12px;
  font-weight: 600;
  margin-top: 2px;
}
.avance-track {
  margin-top: 6px;
  height: 6px;
  width: 92px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--pt-track);
}
.avance-fill {
  height: 100%;
  border-radius: 999px;
}
.avance-num {
  font-size: 11px;
  color: var(--pt-muted);
  margin-top: 2px;
  font-variant-numeric: tabular-nums;
}
.sem {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
}
.sem-fecha {
  color: var(--pt-dim);
  font-size: 11px;
  margin-top: 2px;
}
.sem-original {
  color: var(--pt-muted);
  font-size: 11px;
  text-decoration: line-through;
}
.sin-seg {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #d97706;
}
.empty {
  text-align: center;
  font-size: 14px;
  color: var(--pt-muted);
  padding: 32px 0;
}
.pendiente {
  color: var(--pt-muted);
  font-style: italic;
}
</style>
